import { DependencyList, useLayoutEffect } from 'react';

function useDelayedEffect(func: Function, deps: DependencyList | undefined) {
    return useLayoutEffect(() => {
        const timer = setTimeout(() => {
            func();
        }, 2000);
        return () => clearTimeout(timer);
    }, deps);
}

export default useDelayedEffect;
